var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "header"
  }, [_c('b-navbar', {
    staticStyle: {
      "flex-wrap": "nowrap"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark"
    }
  }, [_vm.isLayoutMobile || _vm.isLayoutMobileLandscape ? _c('a', {
    staticClass: "navbar-arrow nav-link cursor-pointer toggle-sidebar",
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "icon icon-menu-bars"
  })]) : _vm._e(), _c('a', {
    staticClass: "navbar-title nav-link text-primary"
  }, [_c('Breadcrumbs')], 1), _c('b-navbar-toggle', {
    staticClass: "d-none",
    attrs: {
      "target": "nav-collapse"
    }
  }), _c('div', {
    staticClass: "ml-auto d-flex"
  }, [_c('AlarmNotificationsHeaderMenu')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }